import * as React from 'react';
import { connect } from 'react-redux';

import { ModalFrame, ModalFrameEntity, ModalFrameInner } from 'components/modal';
import ModalFrameTabs from 'components/modal/modal-frame-tabs/ModalFrameTabs';

import BrandsFilter from './BrandsFilter';

import { availableBrandFiltersSelector } from 'selectors/brand-filters/brandFilters';

import type { Data, InfluencerMeta, InfluencerMetaKey, InfluencerProfile } from 'types';

type OwnProps = {
  title: string,
  dataProps?: Data,
  children: React.ReactNode,
  influencerProfile: InfluencerProfile,
  metaKey: InfluencerMetaKey,
  influencerMeta: InfluencerMeta,
  hideCount?: boolean
};

type StateProps = {
  availableFilters: Array<string>
};

type Props = OwnProps & StateProps;

const BrandTabsModal = ({
  children,
  influencerProfile,
  title,
  dataProps,
  availableFilters,
  metaKey,
  influencerMeta,
  hideCount
}: Props) => (
  <ModalFrame
    title={title}
    data={dataProps}
  >
    <ModalFrameEntity
      influencerProfile={influencerProfile}
    />
    <React.Fragment>
      {availableFilters.length > 1 &&
        <ModalFrameTabs>
          <BrandsFilter
            metaKey={metaKey}
            influencerMeta={influencerMeta}
            mode="tabs"
            hideCount={hideCount}
          />
        </ModalFrameTabs>
      }
      <ModalFrameInner>
        {children}
      </ModalFrameInner>
    </React.Fragment>
  </ModalFrame>
);

const mapStateToProps = (state): StateProps => ({
  availableFilters: availableBrandFiltersSelector(state)
});

export default connect(mapStateToProps)(BrandTabsModal);
